import React, { createContext, useContext, ReactNode } from 'react';
import { useNavigationHealth } from '../hooks/useNavigationHealth';

interface HealthyNavigationContextType {
  healthyNavigate: (
    to: string,
    options?: { replace?: boolean; state?: any },
    type?: 'sidebar' | 'button' | 'form' | 'programmatic'
  ) => Promise<void>;
  isNavigating: boolean;
  lastNavigation: string;
  healthStatus: 'improving' | 'stable' | 'degrading';
}

const HealthyNavigationContext = createContext<HealthyNavigationContextType | null>(null);

interface HealthyNavigationProviderProps {
  children: ReactNode;
  options?: {
    enableHealthCheck?: boolean;
    enableAutoRecovery?: boolean;
    performanceThreshold?: number;
  };
}

export const HealthyNavigationProvider: React.FC<HealthyNavigationProviderProps> = ({
  children,
  options = {}
}) => {
  const navigationHealth = useNavigationHealth(options);

  return (
    <HealthyNavigationContext.Provider value={navigationHealth}>
      {children}
    </HealthyNavigationContext.Provider>
  );
};

export const useHealthyNavigation = () => {
  const context = useContext(HealthyNavigationContext);
  if (!context) {
    throw new Error('useHealthyNavigation must be used within HealthyNavigationProvider');
  }
  return context;
};

export default HealthyNavigationProvider;
